<template>
    <nav v-if="settingsPage" class="navbar fixed-top navbar-dark navbar-expand-lg bg-dark">

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">

            <ul class="navbar-nav">

                <li class="nav-item active">
                    <a class="nav-link" href="#" @click="goBackToDictionary"><font-awesome-icon icon="arrow-left"/> Back</a>
                </li>

                <li class="nav-item active" v-if="!disableAuth">
                    <a class="nav-link" :class="{loggedin: username != null, notloggedin: username === null}" href="#" @click="doLogin"><font-awesome-icon icon="user"/>{{username !== null ? " "+username : ""}}</a>
                </li>

            </ul>

        </div>

    </nav>
    <nav v-else-if="authPage" class="navbar fixed-top navbar-dark navbar-expand-lg bg-dark">

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">

            <ul class="navbar-nav">

                <li class="nav-item active">
                    <a class="nav-link" href="#" @click="goBackToDictionary"><font-awesome-icon icon="arrow-left"/> Back</a>
                </li>

            </ul>

        </div>

    </nav>
      <nav v-else class="navbar fixed-top navbar-dark navbar-expand-lg bg-dark">

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">

            <form v-on:submit.prevent="doConvert" class="form-inline" id="convert-form" v-on:keyup.enter="submit">
                <input
                        id="convert-input"
                        v-model="convertText"
                        v-on:input="handleConvertChange"
                        class="form-control"
                        type="convert"
                        placeholder="Convert Wylie/Unicode"
                        aria-label="Convert Wylie/Unicode"
                        v-bind:class="{ 'large-font': largeFont}"
                        autocomplete="off"
                        autocorrect="off"
                        autocapitalize="off"
                        spellcheck="false"
                />
                <div id="converter-popup"
                     v-if="converterPopupText != null"
                     v-bind:class="{ 'large-font': largeFontPopup}"
                >
                    {{converterPopupText}}
                </div>
            </form>

            <ul class="navbar-nav ml-auto">

                <li class="nav-item dropdown search-history-nav">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        History
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" v-for="(historyItem, index) in searchHistory" href="#" :key="index" @click="doShowHistoryItem(historyItem)">{{limitLength(historyItem.searchText)}} / <span style="color:grey;">{{getSearchTypeText(historyItem.searchType)}}</span></a>
                    </div>
                </li>

                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown2" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Limit ({{limit}})
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <a v-for="val in limits" class="dropdown-item" :class="{ disabled: val === limit }" href="#" :key="val" @click="setLimit(val)">{{val}}</a>
                    </div>
                </li>

                <li class="nav-item active">
                    <a class="nav-link" href="#" @click="showWylie=!showWylie">{{ showWylie ? 'Hide' : 'Show' }} Wylie</a>
                </li>

                <li class="nav-item active settings-nav">
                    <a class="nav-link" href="#" @click="goToSettings"><font-awesome-icon icon="cog"/> Settings</a>
                </li>

                <li class="nav-item active" v-if="!disableAuth">
                    <a class="nav-link" :class="{loggedin: username != null, notloggedin: username === null}" href="#" @click="doLogin"><font-awesome-icon icon="user"/></a>
                </li>

            </ul>

        </div>

    </nav>
</template>
<!-- eslint-disable no-control-regex -->
<script>
  import { mapState } from 'vuex'
  import { mapMutations } from 'vuex'
  import jsEwts from '../jsewts'

  export default {
    name: 'ImageBanner',
    props: {
      numberOfResults: Number,
      updateSearchType: Function,
      searchHistory: Array,
      doShowHistoryItem: Function,
      setLimit: Function,
      limit: Number,
      limits: Array,
      getSearchTypeText: Function,
      settingsPage: {
        type: Boolean,
        value: false
      },
      authPage: {
        type: Boolean,
        value: false
      },
      disableAuth: {
        type: Boolean,
        value: true
      }
    },
    data: () => {
      return {
        convertText: null,
        largeFont: false,
        largeFontPopup: false,
        converterPopupText: null,
        navbarOpen: false
      }
    },
    computed: {
      ...mapState('app', [
        'searchText',
        'searchTypeText',
        'searchType'
      ]),
      ...mapState('user', [
        'username'
      ]),
      showWylie: {
        get () { return this.$store.state.app.showWylie},
        set (value) { this.setShowWylie(value) }
      }
    },
    methods: {
      ...mapMutations('app', [
        'setShowWylie'
      ]),
      goToSettings() {
        this.$router.push({path:'/settings'});
      },
      goBackToDictionary() {
        this.$router.push({ path: '/'});
      },
          doLogin() {
      this.$router.push({ name: 'Login' });
    },  
      limitLength(string) {
        if (!string) {
          return '';
        }
        if (string.length>20) {
          return string.slice(0,20) + "...";
        }
        else {
          return string;
        }
      },
      doConvert() {
        if (!this.convertText) return;

        if (this.convertText.match(/[^\u0000-\u007F]+/g)) {

          const converted = jsEwts.toWylie(this.convertText);
          this.$log.info(converted);
          if (converted.length > 10) {
            this.converterPopupText = converted;
            this.largeFontPopup = false;
          }
          else {
            this.converterPopupText = null;
            this.convertText = converted;
            this.largeFont = false;
          }
        }
        else {
          const converted = jsEwts.toUnicode(this.convertText);
          this.$log.info(converted);
          if (converted.length > 10) {
            this.converterPopupText = converted;
            this.largeFontPopup = true;
          }
          else {
            this.converterPopupText = null;
            this.convertText = converted;
            this.largeFont = true;
          }
        }
      },
      handleConvertChange() {
        if (!this.convertText) {
          this.largeFont = false;
          this.converterPopupText = null;
        }
        else {
          this.$log.debug(this.convertText.match(/[^\u0000-\u007F]+/g));
          this.largeFont = this.convertText.match(/[^\u0000-\u007F]+/g) != null ? true : false;
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .notloggedin {
        opacity: 0.3;
    }

    .loggedin {
        opacity: 1.0;
    }

    .fixed-top {
        opacity: 1.0;
    }

    .fixed-top.bg-light {
        background-color: var(--yellowish) !important;
    }

    #convert-input.large-font {
        font-size:1.75rem;
    }

    #convert-input {
        height:45px;
        color: white;
        background-color: transparent;
        border: none;
        box-shadow: none;
        width: 100%;
    }

    #convert-form:focus,#convert-input:focus {
        outline: 0 !important;
    }

    #convert-form {
        width: 350px;
    }

    :active {
        outline:none;
    }

    #converter-popup {
        height: auto;
        min-height: 45px;
        font-size: 1.2rem;
        width: 350px;
        position: absolute;
        background-color: rgba(52, 58, 64, 0.8) !important;
        border: 5px solid gray;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        top: 100%;
        left: 0px;
        color: white;
        text-align: left;
        padding: 10px;
        -webkit-box-shadow: 3px 3px 4px 0px rgba(0,0,0,0.2);
        -moz-box-shadow: 3px 3px 4px 0px rgba(0,0,0,0.2);
        box-shadow: 3px 3px 4px 0px rgba(0,0,0,0.2);
    }

    #converter-popup.large-font {
        font-size: 1.8rem;
    }

    nav.navbar {
        -webkit-box-shadow: 3px 3px 4px 0px rgba(0,0,0,0.2);
        -moz-box-shadow: 3px 3px 4px 0px rgba(0,0,0,0.2);
        box-shadow: 3px 3px 4px 0px rgba(0,0,0,0.2);
        min-height: 61px;
    }

    /* Desktop - maintain fixed height */
    @media (min-width: 992px) {
        nav.navbar {
            height: 61px;
        }
    }

    /* Mobile - allow auto height for expansion */
    @media (max-width: 991px) {
        nav.navbar {
            height: auto;
        }
    }

</style>
